var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{class:_vm.getTableClass,style:(_vm.tableStyles),attrs:{"id":_vm.id,"dummy":_vm.dummy}},[_c('thead',[_vm._t("thead")],2),_c('tfoot',[_vm._t("tfoot")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }